import { Component } from '@angular/core'
import { MessageComponent } from '../message/message.component'

@Component({
    selector: 'mga-warning',
    templateUrl: '../message/message.component.html',
    styleUrls: ['../message/message.component.scss', './warning.component.scss'],
})
export class WarningComponent extends MessageComponent {
    icon = 'warning'
}
